module.exports = __webpack_public_path__ + "img/jobmule_settore.17ce2a0d.png";